import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import "./css/HireProfessionals.css";
import CallbackRequestPopup from "./CallbackRequestPopup";
import { useNavigate } from "react-router-dom";

const HireProfessionals = () => {
  const [showCallbackPopup, setShowCallbackPopup] = useState(false);
  const navigate = useNavigate();

  const openCallbackPopup = () => {
    navigate("/contact");
  };

  const closeCallbackPopup = () => {
    setShowCallbackPopup(false);
  };

  const handlePostJob = () => {
    navigate("/post-job"); // Navigate to the post job page
  };

  return (
    <>
      <div className="hire-professionals-wrapper">
        <div className="hire-prof-container">
          <div className="hire-prof-content">
            <h1>AI-Powered Recruitment Solutions for Recruiters</h1>
            <h3>Hire job-ready professionals, faster.</h3>
            <p>
              Pick from our pool of qualified & pre-trained candidates. Increase
              your interview-to-offer ratio.
            </p>

            <div className="hiring-types">
              <span>Lateral Hiring</span>
              <span className="dot-separator">•</span>
              <span>Off-Campus Hiring</span>
              <span className="dot-separator">•</span>
              <span>Campus Hiring</span>
            </div>

            <div className="actions-buttons">
              <button
                className="btn btn-outline-primary"
                onClick={openCallbackPopup}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#006600";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#6600CC";
                }}
              >
                Request a callback
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={handlePostJob}
                style={{ backgroundColor: "#6600CC", color: "white" }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#006600";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#6600CC";
                  e.target.style.color = "white";
                }}
              >
                Post a Job for Free <ArrowRight size={16} />
              </button>
            </div>
          </div>

          <div className="hire-prof-video">
            <div className="imags-container">
              <img
                src="../../../images/recruiters/group-3.jpg"
                alt="Hiring professionals"
                className="hero-image"
              />
            </div>

            <div className="stats-bar">
              <div className="stat-item">
                <h2>100+</h2>
                <p>Verified Talent</p>
              </div>
              <div className="stat-item">
                <h2>Zero</h2>
                <p>
                  Hiring
                  <br />
                  Cost
                </p>
              </div>
              <div className="stat-item">
                <h2>50+</h2>
                <p>
                  Hiring
                  <br />
                  Companies
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CallbackRequestPopup
        isOpen={showCallbackPopup}
        onClose={closeCallbackPopup}
      />
    </>
  );
};

export default HireProfessionals;
